import {
  Box,
  Card,
  CardBody,
  Container,
  Heading,
  List,
  ListIcon,
  ListItem,
  SimpleGrid,
  Text,
  VStack,
} from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'
import { FiArrowRight, FiCheckCircle } from 'react-icons/fi'

const apiSections = [
  {
    title: 'Доступ и организация',
    path: '/api/access-org',
    endpoints: '/login, /users, /org',
    description: 'Авторизация, пользователи, роли и структура организации.',
  },
  {
    title: 'Производственный контур',
    path: '/api/production',
    endpoints: '/objects, /object-templates, /blocks, /brigs, /reports',
    description: 'Объекты, блоки, бригады и экспорт производственных отчётов.',
  },
  {
    title: 'Складской контур',
    path: '/api/warehouse',
    endpoints: '/warehouse/*',
    description: 'Категории, материалы, движения, резервы, заявки.',
  },
  {
    title: 'Платформа и интеграции',
    path: '/api/platform',
    endpoints: '/tariffs, /subscription, /notifications, /announcements, /ws',
    description: 'Тарифы, подписки, уведомления и realtime-каналы.',
  },
]

export const ApiPage: React.FC = () => {
  return (
    <Container maxW="container.xl" py={8}>
      <VStack align="stretch" spacing={6}>
        <Box>
          <Heading as="h1" size="2xl" color="brand.500" mb={3}>
            🔌 API и интеграции
          </Heading>
          <Text color="gray.600" fontSize="lg">
            Backend построен на FastAPI. Базовый префикс API: <strong>/api/v1</strong>.
          </Text>
        </Box>

        <Card>
          <CardBody>
            <Heading size="sm" mb={3}>Как пользоваться этим разделом</Heading>
            <List spacing={2}>
              <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Выберите нужную категорию API в меню слева.</ListItem>
              <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Внутри страницы смотрите группы эндпоинтов и назначение.</ListItem>
              <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Для frontend используйте Bearer-токен и автогенерированный клиент.</ListItem>
            </List>
          </CardBody>
        </Card>

        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
          {apiSections.map((section) => (
            <Card key={section.title} as={RouterLink} to={section.path} _hover={{ textDecoration: 'none', borderColor: 'brand.300' }}>
              <CardBody>
                <Heading size="sm" mb={2}>{section.title}</Heading>
                <Text fontSize="sm" color="gray.600" mb={2}>{section.description}</Text>
                <Text fontSize="sm" color="gray.500" mb={2}>{section.endpoints}</Text>
                <Text color="brand.600" fontSize="sm" fontWeight="semibold" display="inline-flex" alignItems="center" gap={1}>
                  Открыть раздел <FiArrowRight />
                </Text>
              </CardBody>
            </Card>
          ))}
        </SimpleGrid>
      </VStack>
    </Container>
  )
}
